import { CalendarSurfaceItemContentProps } from './CalendarSurfaceItem.types';
import calculateFieldSizing from '../../utils/calculateFieldSizings';
import getInnerHeight from '../../utils/getInnerHeight';
import getLineHeight from '../../utils/getLineHeight';
import CalendarSurfaceItemClipping from '../CalendarSurfaceItemClipping';
import { renderCharmWrapper, renderIconWrapper } from '../CalendarSurfaceItemComponentRenderer';
import { observer } from 'mobx-react';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import loc from 'owa-localize';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('../CalendarSurfaceItem.scss');

/**
 * State for the CalendarSurfaceItemUnder60
 */
export interface CalendarSurfaceItemUnder60State {
    lineHeight: number;
    lines: number;
}

/**
 * The Component for a Calendar Surface item under 60 minutes long
 */
@observer
export default class CalendarSurfaceItemUnder60 extends React.Component<
    CalendarSurfaceItemContentProps,
    CalendarSurfaceItemUnder60State
> {
    wrapperRef: HTMLElement;
    subjectRef: HTMLElement;
    asyncId: number;

    constructor(props: CalendarSurfaceItemContentProps) {
        super(props);
        this.state = {
            lineHeight: getLineHeight(this.subjectRef),
            lines: 0,
        };
    }

    render() {
        const { item, colorScheme, charmId, allowEmptySubject } = this.props;
        const { lineHeight, lines } = this.state;

        let subject = item.Subject;
        if (!subject && !allowEmptySubject) {
            subject = loc(noSubject);
        }
        const location = item.Location && item.Location.DisplayName;
        const organizer = item.Organizer && item.Organizer.Mailbox.Name;

        return (
            <>
                <div
                    className={styles.itemContent}
                    ref={wrapperRef => {
                        this.wrapperRef = wrapperRef;
                    }}>
                    <h2
                        className={styles.itemSubject}
                        ref={subjectRef => {
                            this.subjectRef = subjectRef;
                        }}>
                        <CalendarSurfaceItemClipping lineHeight={lineHeight} lines={lines}>
                            {renderCharmWrapper(item, colorScheme, charmId)}
                            <span>{subject}</span>
                        </CalendarSurfaceItemClipping>
                    </h2>
                    {location && (
                        <div
                            className={classNames(
                                styles.locationWrapper,
                                styles.itemElementContent,
                                styles.calendarItemClippingLine
                            )}>
                            <span>{location}</span>
                            {renderIconWrapper(item, false)}
                        </div>
                    )}
                    {!location && item.IsMeeting && (
                        <div
                            className={classNames(
                                styles.locationWrapper,
                                styles.itemElementContent,
                                styles.calendarItemClippingLine
                            )}>
                            <span>{organizer}</span>
                            {renderIconWrapper(item, false)}
                        </div>
                    )}
                    {!location && !(item.IsMeeting && organizer) && renderIconWrapper(item, false)}
                </div>
            </>
        );
    }

    public componentDidMount() {
        this.asyncId = requestAnimationFrame(() => this.resetFieldSizing());
    }

    public componentWillUnmount() {
        if (this.asyncId) {
            cancelAnimationFrame(this.asyncId);
        }
    }

    private resetFieldSizing() {
        let lineHeights = [
            SurfaceConstants.subjectLineHeight,
            SurfaceConstants.detailsLineHeight,
            SurfaceConstants.detailsLineHeight,
        ];
        let totalHeight = getInnerHeight(this.wrapperRef);
        let subjectHeight = getInnerHeight(this.subjectRef);
        let locationHeight =
            this.props.item.Subject && this.props.item.Location
                ? SurfaceConstants.detailsLineHeight
                : 0;
        let organizerHeight =
            this.props.item.Organizer && this.props.item.IsMeeting
                ? SurfaceConstants.detailsLineHeight
                : 0;

        let lines = calculateFieldSizing(lineHeights, totalHeight, [
            subjectHeight,
            locationHeight,
            organizerHeight,
        ]);

        // making room for the iconwrapper:
        // if the subject is going down to the bottom, it'll overlap- remove bottom line of subject
        if (subjectHeight >= totalHeight - lineHeights[0] && lines[1] == 0) {
            lines[0] = lines[0] - 1;
        }

        this.setState({
            lineHeight: lineHeights[0],
            lines: lines[0],
        });
    }
}
